module.exports = __webpack_public_path__ + "img/b2.0629b57f.jpg";